/**
 * The web implementation of `@/payments/purchases`, wired by a Vite alias.
 *
 * RevenueCat is a native module and `purchases.ts` imports `Platform` from react-native
 * at module scope, so it cannot be bundled for a browser at all. Nothing here needs it:
 * on the web, credits are bought through Stripe Checkout (src/payments/webCheckout.ts,
 * which was written for exactly this client). These no-ops exist so AuthContext — which
 * calls configurePurchases on sign-in — is reusable unchanged.
 */
export interface PaidPackage {
  id: string;
  priceString: string;
  pkg: unknown;
}

export type PurchaseResult =
  | { status: 'purchased'; active: boolean }
  | { status: 'cancelled' }
  | { status: 'unavailable' }
  | { status: 'error'; message: string };

export async function configurePurchases(_userId: string | undefined): Promise<void> {}

export async function resetPurchasesUser(): Promise<void> {}

export async function getSubscriptionPackage(): Promise<PaidPackage | null> {
  return null;
}

export async function purchase(_p: PaidPackage): Promise<PurchaseResult> {
  return { status: 'unavailable' };
}

export async function restorePurchases(): Promise<boolean> {
  return false;
}

/** False on the web on purpose: the browser buys credits through Stripe, not IAP. */
export async function purchasesAvailable(): Promise<boolean> {
  return false;
}
